// extracted by mini-css-extract-plugin
module.exports = {"divider":"FormBoxDivider_divider_2ZQsJ"};